import React, { useState } from 'react';
import axios from 'axios';

const FeedbackForm = () => {
    const [feedback, setFeedback] = useState('');
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');

    const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.hostname === "localhost" ? "http://localhost:5000" : "");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        try {
            await axios.post(`${API_BASE_URL}/api/feedback`, { feedback, email });
            setStatus('success');
            setFeedback('');
        } catch (error) {
            console.error(error);
            setStatus('error');
        }
    };

    return (
        <div style={{ marginTop: '20px', padding: '15px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
            <h5 style={{ color: '#00ccff', marginBottom: '10px' }}>Your Feedback Matters!</h5>
            <p style={{ fontSize: '0.8rem', marginBottom: '10px' }}>Help us improve and win a free Semester Plan!</p>

            {status === 'success' ? (
                <p style={{ color: '#4caf50' }}>Thank you for your feedback!</p>
            ) : (
                <form onSubmit={handleSubmit}>
                    <textarea
                        value={feedback}
                        onChange={(e) => setFeedback(e.target.value)}
                        placeholder="Share your thoughts..."
                        required
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: 'none', minHeight: '60px', background: '#333', color: '#fff' }}
                    />
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email (for rewards)"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: 'none', background: '#333', color: '#fff' }}
                    />
                    <button
                        type="submit"
                        disabled={status === 'sending'}
                        style={{ width: '100%', padding: '8px', background: '#00ccff', color: '#000', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                        {status === 'sending' ? 'Sending...' : 'Submit Feedback'}
                    </button>
                    {status === 'error' && <p style={{ color: '#ff4444', fontSize: '0.8rem', marginTop: '5px' }}>Failed to send. Try again.</p>}
                </form>
            )}
        </div>
    );
};

export default FeedbackForm;
